const scalesDefault = {
  yAxes: [{
    type: 'linear',
    ticks: {
      beginAtZero: true,
      min: 0,
    },
    min: 0,
  }],
  xAxes: [{
    type: 'time',
    time: {
      displayFormats: {
        year: 'YYYY',
        quarter: '[Q]Q YYYY',
        month: 'MMM YYYY',
        week: 'DD MMM',
        day: 'DD MMM',
        hour: 'HH:00',
      },
      isoWeekday: true,
      tooltipFormat: 'DD/MM/YY',
    },
    distribution: 'series',
    gridLines: {
      offsetGridLines: true,
    },
    offset: true,
  }],
}

export default scalesDefault
